import { isSuccess } from './is-success'
import { get } from 'lodash'
import { empty } from 'utils/empty'

export function transformResponse(response, dataKey) {
    return {
        success: isSuccess(response.status),
        message: response.data?.message || '',
        data: dataKey ? get(response.data, dataKey, null) : (response.data ?? null),
        errors:
            typeof response.data?.errors === 'object' && !empty(response.data.errors)
                ? response.data.errors
                : null,
        code: response.status,
    }
}
